<div class="p-2 m-auto" style="width: 350px;" fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="row" fxLayoutGap="10px" class="mb-3">
        <button mat-button color="sims" (click)="setState(states.DAILY)" [disabled]="state == states.DAILY">{{'daily' | translate}}</button>
        <button mat-button color="sims" (click)="setState(states.WEEKLY)" [disabled]="state == states.WEEKLY">{{'weekly' | translate}}</button>
        <button mat-button color="sims" (click)="setState(states.MONTHLY)" [disabled]="state == states.MONTHLY">{{'monthly' | translate}}</button>
    </div>

    <div [ngSwitch]="state">

        <form [formGroup]="form">
            <div *ngSwitchCase="states.DAILY">
                <ng-container *ngTemplateOutlet="time, context: { formGroup: form }"></ng-container>
            </div>

            <div *ngSwitchCase="states.WEEKLY">
                <ng-container *ngTemplateOutlet="time, context: { formGroup: form }"></ng-container>
                <ng-container *ngTemplateOutlet="week, context: { formGroup: form }"></ng-container>
            </div>

            <div *ngSwitchCase="states.MONTHLY">
                <ng-container *ngTemplateOutlet="time, context: { formGroup: form }"></ng-container>
                <ng-container *ngTemplateOutlet="month, context: { formGroup: form }"></ng-container>
            </div>
        </form>

        <div *ngSwitchDefault>
            <p>{{'selectFrequency' | translate}}</p>
        </div>
    </div>
</div>

<ng-template #time let-formGroup="formGroup">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="30px" [formGroup]="formGroup">
        <mat-form-field appearance="outline" style="width: 85px;" color="sims">
            <mat-label>{{'hour' | translate}}</mat-label>
            <div style="width: 100%;" fxLayout="row" fxLayoutAlign="center center">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon svgIcon="expand_less" class="counter-icon" (click)="formGroup.controls[formFiled.HOUR].value + 1 < 24 ? formGroup.controls[formFiled.HOUR].patchValue(formGroup.controls[formFiled.HOUR].value + 1) : formGroup.controls[formFiled.HOUR].patchValue(0)"></mat-icon>
                    <input matInput type="number" matInput max="23" min="0" formControlName="{{formFiled.HOUR}}" class="m-1 input-number">
                    <mat-icon svgIcon="expand_more" class="counter-icon" (click)="formGroup.controls[formFiled.HOUR].value - 1 > 0 ? formGroup.controls[formFiled.HOUR].patchValue(formGroup.controls[formFiled.HOUR].value - 1) : formGroup.controls[formFiled.HOUR].patchValue(23)"></mat-icon>
                </div>
            </div>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 85px;">
            <mat-label>{{'minutes' | translate}}</mat-label>
            <div style="width: 100%;" fxLayout="row" fxLayoutAlign="center center">
                <div fxLayout="column" fxLayoutAlign="center center">
                    <mat-icon svgIcon="expand_less" class="counter-icon" (click)="formGroup.controls[formFiled.MINUTE].value + 1 < 60 ? formGroup.controls[formFiled.MINUTE].patchValue(formGroup.controls[formFiled.MINUTE].value + 1) : formGroup.controls[formFiled.MINUTE].patchValue(0)"></mat-icon>
                    <input matInput type="number" max="59" min="0" formControlName="{{formFiled.MINUTE}}" class="m-1 input-number">
                    <mat-icon svgIcon="expand_more" class="counter-icon" (click)="formGroup.controls[formFiled.MINUTE].value - 1 > 0 ? formGroup.controls[formFiled.MINUTE].patchValue(formGroup.controls[formFiled.MINUTE].value - 1) : formGroup.controls[formFiled.MINUTE].patchValue(59)"></mat-icon>
                </div>
            </div>
        </mat-form-field>
    </div>
</ng-template>

<ng-template #week let-formGroup="formGroup">
    <div [formGroup]="formGroup">
        <mat-form-field appearance="outline">
            <mat-label>{{'dayOfWeek' | translate}}</mat-label>
            <mat-select multiple formControlName="{{formFiled.DAY_OF_WEEK}}" [compareWith]="isEqualWeek">
                <mat-option *ngFor="let day of days" [value]="dayOfWeek[day]">{{dayOfWeek[day] |
                    translate}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>

<ng-template #month let-formGroup="formGroup">
    <div [formGroup]="formGroup">
        <mat-form-field appearance="outline">
            <mat-label>{{'dayOfMonth' | translate}}</mat-label>
            <mat-select multiple formControlName="{{formFiled.DAY_OF_MONTH}}" [compareWith]="isEqual">
                <mat-option *ngFor="let day of daysOfMonth" [value]="day + 1">{{day + 1}}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</ng-template>